/**
 * Public Share Slice
 *
 * Marks the store as running in public share-viewer mode (`/share/:token`,
 * `/embed/:token`). The flag is consulted by interaction hooks to disable
 * editing affordances (dblclick-edit, context menus) and by `mapLayersSlice`
 * to skip persisting layer preferences to the authenticated API.
 *
 * @module store/slices/publicShareSlice
 */

// ===== SLICE INTERFACE =====

export interface PublicShareSlice {
  publicShare: {
    /**
     * Share token of the currently viewed public share, null outside public
     * mode. Public-share mode is derived from this (`token !== null`) — there
     * is no separate boolean flag to keep in sync.
     */
    token: string | null;
    enterPublicShare: (token: string) => void;
    exitPublicShare: () => void;
  };
}

// ===== SLICE CREATOR =====

export const createPublicShareSlice = (
  set: (fn: (state: PublicShareSlice) => void) => void,
  _get: () => PublicShareSlice,
  _store: unknown
) => ({
  publicShare: {
    token: null,

    enterPublicShare: (token: string) => {
      set((state) => {
        state.publicShare.token = token;
      });
    },

    exitPublicShare: () => {
      set((state) => {
        state.publicShare.token = null;
      });
    },
  },
});
